import { ICandidate } from '../../../interfaces/graph-types';
import { AccountService } from '../../../services/account.service';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';

type onSelectTag = (
  addTagIds: string[],
  removeTagIds: string[],
  onsuccess: onSmartSuccess,
  onfailure: onSmartFailure,
) => void;

@Component({
  selector: 'modal-tags-selector',
  template: require('./modal-tags-selector.component.pug'),
  styles: [require('./modal-tags-selector.component.css').toString()],
})
export class ModalTagsSelectorComponent implements OnInit {
  // Options to pass to the modal:
  accountId: string;
  onSelect: onSelectTag;

  // -------------------------------------------------------------------
  constructor(
    public bsModalRef: BsModalRef,
    private accountService: AccountService,
  ) {}

  tags_on = null;
  tags_off = null;

  // -------------------------------------------------------------------
  ngOnInit() {
    this.accountService.candidateTags(this.accountId).subscribe(tags => {
      if (tags) {
        this.tags_on = [];
        this.tags_off = [];

        tags.forEach(tag => {
          this.tags_on.push({ id: tag.id, name: tag.name, onoff: true });
          this.tags_off.push({ id: tag.id, name: tag.name, onoff: false });
        });
      }
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {}

  // -------------------------------------------------------------------
  tagging(tag: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    tag.value = !tag.value;

    if (tag.value) {
      // remove from the other possibility as we can't have both "should have" and "should not have"
      if (tag.onoff) {
        this.tags_off = this.tags_off.filter(el => el.id != tag.id);
      } else {
        this.tags_on = this.tags_on.filter(el => el.id != tag.id);
      }
    } else {
      // re-add in previous array
      if (tag.onoff) {
        this.tags_off.push({ id: tag.id, name: tag.name, onoff: false });
      } else {
        this.tags_on.push({ id: tag.id, name: tag.name, onoff: true });
      }
    }
    onsuccess();
  }

  // -------------------------------------------------------------------
  validate(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    let tag_ids_on = [];
    let tag_ids_off = [];

    this.tags_on.forEach(tag => {
      if (tag.value) {
        tag_ids_on.push(tag.id);
      }
    });

    this.tags_off.forEach(tag => {
      if (tag.value) {
        tag_ids_off.push(tag.id);
      }
    });

    this.onSelect(tag_ids_on, tag_ids_off, onsuccess, onfailure);
  }
}
